// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3jPbV","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1FluF"};